import { posthog } from '@/features/flags/posthog-compat';
import { getCurrentUser } from '@/hooks/query/useQueryUser';

// This is a hacky solution to ensure StriveHealth have the correct copy fn. Currently, PH flags are not working for them.
// In future, Product believes this will be handled elegantly by template code snippets. Alternatively, this could also be fixed when we implement internal feature flags.
// Hard coding this was approved as an interim fix as we do not want fully fledged user-facing controls for this nor do we want a toggle in IA for it.
export const IS_BLOCK_EDITOR_MARKDOWN_ENABLED = () => {
  const user = getCurrentUser();
  const userEmail = user?.email || '';
  if (userEmail.includes('@strivehealth')) {
    return false;
  }
  return posthog.isFeatureEnabled('release-block-editor-markdown') ?? false;
};

export const IS_COPY_FULL_MARKDOWN_ENABLED = () => {
  const user = getCurrentUser();
  const userEmail = user?.email || '';
  if (userEmail.includes('@strivehealth')) {
    return true;
  }
  return posthog.isFeatureEnabled('release-copy-full-markdown');
};
